import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import StatusComp from "../../../components/StatusComp";
import { role_list } from "../../redux/api/dummyJson";
import { merch_toggle_off, merch_toggle_on } from "../../../assets/imgs";

// import apiRequest from "../redux/api/apiRequest";
// import {
//   useLazyPermissionsListQuery,
//   useAddRoleMutation,
//   useLazyViewRoleQuery,
//   useUpdateRoleMutation,
// } from "../redux/api/api";



const AddUserRoles = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState("");
    const [roleList, setRoleList] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [permissionList, setPermissionList] = useState([]);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const [selectedPermission_, setSelectedPermission_] = useState([]);
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);

    const [seperation, setSepertion] = useState()


    const [role, setRole] = useState('');
    const [errors, setErrors] = useState(false);


    const login = () => {
        if (!role) {
            setErrors(true);
        }
        else {
            setErrors(false)
            navigate("/roles");
        }
    };


    // const [permissionsList] = useLazyPermissionsListQuery();
    // const [viewRole] = useLazyViewRoleQuery();
    // const [addRole] = useAddRoleMutation();
    // const [updateRole] = useUpdateRoleMutation();
    const type = location?.state?.type;
    const id = location?.state?.id;

    // const getPermissionsList = async () => {
    //   const res = await apiRequest(permissionsList);
    //   if (res?.status == "success") {
    //     let filert_ = res?.modules?.filter((i) => i?.type == 1)
    //     setRoleList(filert_);
    //     res?.modules?.map((item) => {
    //       let obj = {}
    //       obj.name = item.name
    //       obj.permissions = item.permissions
    //       setSepertion(obj)
    //     })


    //   }
    //   console.log(res);
    // };

    // console.log(seperation, 'seperation');



    // const roleView = async (id) => {
    //   const res = await apiRequest(viewRole, id);
    //   if (res?.status == "success") {
    //     setName(res?.role_data?.name);
    //     setSelectedPermissions(res?.role_data?.permissions);
    //     let temp = []
    //     res?.role?.permissions?.map((item, ind) => {
    //       temp.push(item?.id)
    //     })
    //     setPermissions(temp)

    //     let permissions_ = [...res?.role_data?.permissions]
    //     let parent_id = []
    //     res?.modules?.map((item, ind) => {
    //       let finder = item?.permissions?.filter((i) => permissions_?.includes(i?.id))
    //       if (item?.permissions?.length == finder?.length) {
    //         parent_id.push(item?.id)
    //       }
    //     })
    //     setSelectedPermission_(parent_id)
    //   }
    //   // console.log(res);
    // };

    // const Add = async () => {
    //   if (!name) {
    //     setError(true);
    //     return;
    //   }
    //   if (selectedPermissions?.length == 0) {
    //     setError(true);
    //     return;
    //   }
    //   setError(false);
    //   const formdata = new FormData();
    //   formdata.append("name", name);
    //   selectedPermissions?.map((item, index) => {
    //     formdata.append(`permissions[${index}]`, item);
    //   });
    //   if (type == "edit") {
    //     formdata.append("role_id", id);
    //   }
    //   setLoader(true);
    //   const res = await apiRequest(
    //     type == "edit" ? updateRole : addRole,
    //     formdata
    //   );
    //   setLoader(false);
    //   if (res?.status == "success") {
    //     toast.success(res?.message);
    //     navigate("/role");
    //   }
    // };

    // useEffect(() => {
    //   getPermissionsList();
    //   if (id) {
    //     roleView(id);
    //   }
    // }, []);

    // console.log(selectedPermissions);

    // Handle toggling of permissions
    const handlePermissionToggle = (roleId, per_id) => {
        let selectedlist = [];
        let temp = [...selectedPermission_]
        let finder = roleList?.find((i) => i?.id == per_id)
        let permissions_ = finder?.permissions
        let permissions_id = finder?.permissions?.map((item) => item?.id)

        selectedPermissions.map((item) => {
            if (item != roleId) {
                selectedlist.push(item);
            }
        });
        if (!selectedPermissions?.includes(roleId)) {
            selectedlist.push(roleId);
        }
        setSelectedPermissions(selectedlist);

        let matcher = permissions_id?.filter((i) => selectedlist?.includes(i))
        if (permissions_?.length == matcher?.length) {
            temp.push(per_id)
        } else {
            let inx = temp?.indexOf(per_id)
            if (inx >= 0) {
                temp.splice(inx, 1)
            }
        }
        setSelectedPermission_(temp)
    };




    // const selectRoles = () => {
    //   let ids = [];
    //   let ids_ = []
    //   roleList?.map((item) => {
    //     ids_.push(item.id);
    //     item?.permissions?.map((d) => {
    //       ids.push(d.id);
    //     });
    //   });
    //   if (selectedPermissions.length < ids.length) {
    //     setSelectedPermissions(ids);
    //     setSelectedPermission_(ids_)
    //   } else {
    //     setSelectedPermissions([]);
    //     setSelectedPermission_([])
    //   }
    // };

    const selectRoles = () => {
        const allModuleIds = role_list.map((item) => item.id);
        const allPermissionIds = role_list.map((item) =>
            item.permissions.map((p) => p.id)
        ).flat();

        console.log(allPermissionIds, 'allPermissionIds');


        if (selectedPermissions.length < allPermissionIds.length) {
            setSelectedPermission_(allModuleIds);
            setSelectedPermissions(allPermissionIds);
        } else {
            setSelectedPermission_([]);
            setSelectedPermissions([]);
        }
    };

    console.log(selectedPermission_, 'selectedPermission_')


    const specificRoles = (item) => {
        let ids = [...selectedPermissions];
        let temp = [...selectedPermission_]

        let per_ = []
        item?.permissions?.map((item) => {
            per_.push(item?.id)
        })

        if (selectedPermission_?.includes(item?.id)) {
            let idx = temp?.indexOf(item?.id)
            temp.splice(idx, 1)
            let newArray = ids.filter(item => !per_.includes(item));
            ids = newArray
        } else {
            temp.push(item?.id)
            item?.permissions?.map((item) => {
                ids.push(item?.id)
            })
        }
        setSelectedPermission_(temp)
        setSelectedPermissions(ids)
    };



    return (
        <div className="dashRightView">

            <StatusComp
                name={'Roles'}
                type={type}
            />

            <div className="">

                <div className="roles-bg">


                    <div className="d-flex flex-wrap mt-2 ps-3 gap-2">
                        {role_list?.map((item, id) => {
                            return (
                                <div className="w-24 mt-3 role-box">
                                    <div className="d-flex ac-js gap-2 mb-3">
                                        <p className="f3 fs-xs-10 trans fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0">
                                            {item?.name}
                                        </p>
                                        {type != "view" && (
                                            <img
                                                src={selectedPermission_?.includes(item?.id) ? merch_toggle_on : merch_toggle_off}
                                                className="roles-icon pointer"
                                                alt=""
                                                onClick={() => { specificRoles(item); }}
                                            />
                                        )}
                                    </div>
                                    <div className="d-flex ac-js">
                                        <div>
                                            {item?.permissions?.map((permission, index) => {
                                                const isSelected = selectedPermissions?.includes(
                                                    permission.id
                                                );
                                                return (
                                                    <div className="d-flex ac-js gap-2 mb-2">
                                                        <img
                                                            src={isSelected ? merch_toggle_on : merch_toggle_off}
                                                            className="roles-icon pointer"
                                                            alt=""
                                                            onClick={() => {
                                                                if (type != "view") {
                                                                    handlePermissionToggle(permission.id, item?.id);
                                                                }
                                                            }}
                                                        />
                                                        <p className=" f1 fs-xs-10 trans fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 mb-0 ">
                                                            {permission?.name}
                                                        </p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="d-flex ac-jb">
                        <button onClick={() => navigate(-1)} className="back-btn-roles f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 " >
                            Back
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
};


export default AddUserRoles